module.exports = __webpack_public_path__ + "static/media/Puzzle_Elements2.8763581b.png";